import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { find, map } from "lodash";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { getClassNames, checkLearner } from "../../Js/Common";
import Slide from "@mui/material/Slide";
import { validator } from "../../Js/Validator";

const style = {
  position: "absolute",
  top: "2%",
  left: "40%",
  transform: "translate(-50%, -50%)",
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const AITestGuestInfo = (props) => {
  const containerRef = React.useRef(null);
  const [timeoutObj, setTimeoutObj] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [name, setName] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [city, setCity] = useState("");
  const [designation, setDesignation] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [validate, setValidate] = useState(false);
  const [nameError, setNameError] = useState(null);
  const [schoolNameError, setSchoolNameError] = useState(null);
  const [cityError, setCityError] = useState(null);
  const [designationError, setDesignationError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [alertMsg, setAlertMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  const classname = useStyles();

  // Redux state

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
    if (!initialRender && !props.visible) {
      setErrorMsg(null);
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  const nameBlurValidate = () => {
    let validate = validator({ required: true, value: name.trim() });
    if (!validate["validate"]) {
      setNameError(validate["message"]);
      setValidate(false);
      return false;
    } else {
      setNameError(null);
      setValidate(true);
      return true;
    }
  };

  // Validate password on blur
  const schoolNameBlurValidate = () => {
    let validate = validator({ required: true, value: schoolName.trim() });
    if (!validate["validate"]) {
      setSchoolNameError(validate["message"]);
      setValidate(false);
      return false;
    } else {
      setSchoolNameError(validate["message"]);
      setValidate(false);
      return true;
    }
  };

  // Validate password on blur
  const cityBlurValidate = () => {
    let validate = validator({ required: true, value: city.trim() });
    if (!validate["validate"]) {
      setCityError(validate["message"]);
      setValidate(false);
      return false;
    } else {
      setCityError(validate["message"]);
      setValidate(false);
      return true;
    }
  };

  // Validate password on blur
  const designationBlurValidate = () => {
    let validate = validator({ required: true, value: designation.trim() });
    if (!validate["validate"]) {
      setDesignationError(validate["message"]);
      setValidate(false);
      return false;
    } else {
      setDesignationError(validate["message"]);
      setValidate(false);
      return true;
    }
  };

  // Validate password on blur
  const emailBlurValidate = () => {
    let validate = validator({ required: true, value: email.trim() });
    if (!validate["validate"]) {
      setEmailError(validate["message"]);
      setValidate(false);
      return false;
    } else {
      setEmailError(validate["message"]);
      setValidate(false);
      return true;
    }
  };

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
        >
          <Box
            sx={{
              ...style,
              backgroundColor: "primary.main",
              border: 0,
              borderRadius: 6,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ mb: 1 }} size="small">
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "left",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    Your Name
                  </Typography>
                  <TextField
                    id="yourname"
                    tabIndex={0}
                    placeholder="Enter Your Name"
                    variant="outlined"
                    fullWidth
                    sx={{ bgcolor: "#FFFFFF" }}
                    onBlur={() => {
                      nameBlurValidate();
                    }}
                    onInput={(event) => {
                      setName(event.target.value);
                    }}
                    value={name}
                    helperText={nameError}
                    error={nameError != null}
                    size="small"
                    // onKeyDown={(event) => {
                    //   if (event.keyCode === 13) {
                    //     validateCredentials();
                    //   }
                    // }}
                  />
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      marginTop: 2,
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "left",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    School Name
                  </Typography>
                  <TextField
                    id="schoolname"
                    tabIndex={1}
                    placeholder="Enter School Name"
                    variant="outlined"
                    fullWidth
                    sx={{ bgcolor: "#FFFFFF" }}
                    onBlur={() => {
                      schoolNameBlurValidate();
                    }}
                    onInput={(event) => {
                      setSchoolName(event.target.value);
                    }}
                    value={schoolName}
                    helperText={schoolNameError}
                    error={schoolNameError != null}
                    size="small"
                    // onKeyDown={(event) => {
                    //   if (event.keyCode === 13) {
                    //     validateCredentials();
                    //   }
                    // }}
                  />
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      marginTop: 2,
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "left",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    City
                  </Typography>
                  <TextField
                    id="city"
                    tabIndex={2}
                    placeholder="Enter City Name"
                    variant="outlined"
                    fullWidth
                    sx={{ bgcolor: "#FFFFFF" }}
                    onInput={(event) => {
                      setCity(event.target.value);
                    }}
                    value={city}
                    onBlur={() => {
                      cityBlurValidate();
                    }}
                    helperText={cityError}
                    error={cityError != null}
                    size="small"
                    // onKeyDown={(event) => {
                    //   if (event.keyCode === 13) {
                    //     validateCredentials();
                    //   }
                    // }}
                  />
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      marginTop: 2,
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "left",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    Designation
                  </Typography>
                  <TextField
                    id="designation"
                    tabIndex={2}
                    placeholder="Enter Designation"
                    variant="outlined"
                    fullWidth
                    sx={{ bgcolor: "#FFFFFF" }}
                    onInput={(event) => {
                      setDesignation(event.target.value);
                    }}
                    value={designation}
                    onBlur={() => {
                      designationBlurValidate();
                    }}
                    helperText={designationError}
                    error={designationError != null}
                    size="small"
                    // onKeyDown={(event) => {
                    //   if (event.keyCode === 13) {
                    //     validateCredentials();
                    //   }
                    // }}
                  />
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      marginTop: 2,
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "left",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    Email
                  </Typography>
                  <TextField
                    id="email"
                    tabIndex={2}
                    placeholder="Enter Email"
                    variant="outlined"
                    fullWidth
                    sx={{ bgcolor: "#FFFFFF" }}
                    onInput={(event) => {
                      setEmail(event.target.value);
                    }}
                    value={email}
                    onBlur={() => {
                      emailBlurValidate();
                    }}
                    helperText={emailError}
                    error={emailError != null}
                    size="small"
                    // onKeyDown={(event) => {
                    //   if (event.keyCode === 13) {
                    //     validateCredentials();
                    //   }
                    // }}
                  />
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      marginTop: 2,
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "left",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    Phone
                  </Typography>
                  <TextField
                    id="phone"
                    tabIndex={3}
                    placeholder="Enter Phone"
                    variant="outlined"
                    fullWidth
                    sx={{ bgcolor: "#FFFFFF" }}
                    onInput={(event) => {
                      setPhone(event.target.value);
                    }}
                    value={phone}
                    size="small"
                    // onKeyDown={(event) => {
                    //   if (event.keyCode === 13) {
                    //     validateCredentials();
                    //   }
                    // }}
                  />
                </FormControl>
                <Grid item sx={{ textAlign: "center" }}>
                  {/* {(nameError || schoolNameError) && (
                    <Grid>
                      <Typography className={classname.errorMessage}>
                        {nameError ? nameError : ""}
                      </Typography>
                      <Typography className={classname.errorMessage}>
                        {schoolNameError ? schoolNameError : ""}
                      </Typography>
                    </Grid>
                  )} */}
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: 10,
                      backgroundColor: "#FFF",
                      color: "primary.main",
                      fontWeight: "bold",
                      mt: 3,
                      px: 2,
                     
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                    disabled={nameError || schoolNameError}
                    onClick={() => {
                      if (
                        nameBlurValidate() &&
                        schoolNameBlurValidate() &&
                        cityBlurValidate() &&
                        designationBlurValidate() &&
                        emailBlurValidate()
                      ) {
                        props.go({
                          name,
                          schoolName,
                          city,
                          designation,
                          email,
                          phone,
                        });
                      }
                    }}
                  >
                    Go
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
  errorMessage: {
    backgroundColor: "red",
    color: "#FFFFFF",
    borderRadius: 30,
    padding: "10px 20px",
  },
});
export default AITestGuestInfo;
